import {
    BOOKLIST,
    COMPANY,
    REQUESTED_TITLE,
    RIGHTS_REQUESTS
} from "@legacy/helpers/constants/sharedStatics";

export default {
    BOOKLIST,
    COMPANY,
    REQUESTED_TITLE,
    RIGHTS_REQUESTS
};